import { TypingInfoClientConst } from "../../../viewsHigherOrder/utils/utils_typing";

export const constComunication: TypingInfoClientConst = {
  1: {
    que: "Correos electrónicos",
    res: {
      item1: "servicioalcliente@puntodepago.com.co",
      item2: "servicioalcliente_empresarial@puntodepago.com.co",
    },
  },
  2: {
    que: "Portal de atención Servicio al Cliente:",
    res: {
      item1: "https://puntodepago.freshdesk.com/support/home",
    },
  },
  3: {
    que: "Atención vía WhatsApp App:",
    res: {
      item1: "3176611490",
    },
  },
};
